module.exports = __webpack_public_path__ + "static/img/logo-261-213.d0bf694.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo-261-213.jpg
// module id = 602
// module chunks = 1